var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"title":"Inspecties"}},[_c('b-nav',{attrs:{"tabs":""}},_vm._l((_vm.tabRoutes),function(label,index){return _c('b-nav-item',{key:index,attrs:{"active":_vm.tabRoute == label,"to":{name:label}}},[_vm._v("\n      "+_vm._s(label)+"\n    ")])}),1),_c('b-card-body',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }